<div
  [class]="['sg-label-wrapper', 'label-' + variant, 'label-' + size, 'sg-ui-component']"
  [class.add-gap]="icon && text"
  [class.inverted]="inverted"
  [class.wrap]="wrapText">
  @if (icon) {
  <mat-icon>{{ icon }}</mat-icon>
  }
  <sg-text [variant]="textVariant" [withoutLineHeight]="!wrapText">{{ text }}</sg-text>
</div>
